// extracted by mini-css-extract-plugin
export default {"text-editor-terms":"AddTErmsConditions_text-editor-terms__ahujw"};